import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

export default function CopyButton({ text, label = "Copied", className = "", testid, title }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text || "");
      setCopied(true);
      toast.success(`${label} to clipboard`);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Couldn't copy");
    }
  };
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={copy}
      aria-label={title || "Copy"}
      title={title}
      className={`p-2 rounded-lg text-slate-500 hover:text-[#00E5FF] hover:bg-[#10222A] transition-colors ${className}`}
    >
      {copied ? <Check className="w-4 h-4" strokeWidth={1.5} /> : <Copy className="w-4 h-4" strokeWidth={1.5} />}
    </button>
  );
}
